import { Button } from "@/components/ui/button";
import { Mail, Phone, MapPin, ArrowRight } from "lucide-react";

export default function ContactSection() {
  return (
    <section
      id="contact"
      className="relative border-t border-white/10 bg-gradient-to-b from-[#0A0F1C] to-[#060912]"
      data-testid="contact-section"
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-20 lg:py-24">
        <div className="rounded-3xl border border-white/10 bg-[#111827]/60 backdrop-blur p-8 sm:p-12 lg:p-16 relative overflow-hidden">
          <div className="absolute -top-40 -right-40 w-96 h-96 rounded-full bg-[#F97316]/15 blur-3xl pointer-events-none" />

          <div className="relative grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <div className="text-[11px] uppercase tracking-[0.22em] text-[#F97316]">
                Talk to an Advisor
              </div>
              <h2 className="mt-3 font-heading text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tighter leading-[1.1]">
                Your blueprint is ready.
                <br />
                <span className="italic font-light text-slate-200">Let's make it real.</span>
              </h2>
              <p className="mt-5 text-base text-slate-400 leading-relaxed max-w-lg">
                Share your plan with a Sahi Disha advisor — we'll help you pick the right funds,
                set up your SIP and review it with you every year.
              </p>

              <div className="mt-8 flex flex-wrap gap-3">
                <Button
                  asChild
                  className="bg-[#F97316] hover:bg-[#EA580C] text-white font-medium px-6 h-12 rounded-md shadow-lg shadow-orange-500/20"
                  data-testid="contact-mail-btn"
                >
                  <a href="mailto:info@sahidisha.in?subject=Passive%20Income%20Blueprint%20-%20Help%20me%20set%20up%20my%20SIP&body=Hi%20Sahi%20Disha%20team%2C%0A%0AI%20just%20generated%20my%20Passive%20Income%20Blueprint%20and%20would%20like%20to%20discuss%20the%20next%20steps.%0A%0AThanks%2C">
                    <Mail className="w-4 h-4 mr-2" />
                    Mail us — info@sahidisha.in
                  </a>
                </Button>
                <Button
                  asChild
                  variant="outline"
                  className="bg-transparent border-white/15 hover:bg-white/5 text-white font-medium px-6 h-12 rounded-md"
                  data-testid="contact-call-btn"
                >
                  <a href="tel:9824050200">
                    <Phone className="w-4 h-4 mr-2" />
                    Call +91 98240 50200
                  </a>
                </Button>
              </div>
            </div>

            <div className="grid gap-4">
              <div className="rounded-xl border border-white/10 bg-white/[0.02] p-6">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-md bg-[#F97316]/15 border border-[#F97316]/30 flex items-center justify-center">
                    <Phone className="w-5 h-5 text-[#F97316]" />
                  </div>
                  <div className="text-[11px] uppercase tracking-[0.2em] text-slate-400">
                    Phone
                  </div>
                </div>
                <a
                  href="tel:9824050200"
                  className="mt-4 block font-heading text-2xl font-semibold tracking-tight num-font hover:text-[#F97316] transition-colors"
                  data-testid="contact-phone-link"
                >
                  +91 98240 50200
                </a>
                <div className="mt-1 text-xs text-slate-500">Mon–Sat • 10am – 7pm</div>
              </div>

              <div className="rounded-xl border border-white/10 bg-white/[0.02] p-6">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-md bg-[#F97316]/15 border border-[#F97316]/30 flex items-center justify-center">
                    <Mail className="w-5 h-5 text-[#F97316]" />
                  </div>
                  <div className="text-[11px] uppercase tracking-[0.2em] text-slate-400">
                    Email
                  </div>
                </div>
                <a
                  href="mailto:info@sahidisha.in"
                  className="mt-4 block font-heading text-2xl font-semibold tracking-tight hover:text-[#F97316] transition-colors break-all"
                  data-testid="contact-email-link"
                >
                  info@sahidisha.in
                </a>
                <div className="mt-1 text-xs text-slate-500">Replies within 1 business day</div>
              </div>

              <div className="rounded-xl border border-white/10 bg-white/[0.02] p-6">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-md bg-[#F97316]/15 border border-[#F97316]/30 flex items-center justify-center">
                    <MapPin className="w-5 h-5 text-[#F97316]" />
                  </div>
                  <div className="text-[11px] uppercase tracking-[0.2em] text-slate-400">
                    Office
                  </div>
                </div>
                <address
                  className="mt-4 not-italic text-sm text-slate-300 leading-relaxed"
                  data-testid="contact-address"
                >
                  TF 301, S9 Imperial, Parpada Road corner,<br />
                  above Zudio, opposite Bihari Baug,<br />
                  Abu Highway, Palanpur.
                </address>
                <a
                  href="https://maps.google.com/?q=S9+Imperial+Parpada+Road+Palanpur"
                  target="_blank"
                  rel="noreferrer"
                  className="mt-3 inline-flex items-center gap-1.5 text-xs text-[#F97316] hover:text-[#FB923C] transition-colors"
                  data-testid="contact-map-link"
                >
                  Open in Maps <ArrowRight className="w-3 h-3" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
